import { render } from "./AddressForm.vue?vue&type=template&id=495290ba"
import script from "./AddressForm.ts?vue&type=script&lang=js&external"
export * from "./AddressForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__